'use strict'

import ApiClient from './ApiClient'

export default class UserSettingRepository {
  /**
   * ユーザー情報変更不可設定を取得します。
   * @returns {*}
   */
  get () {
    return ApiClient().get(`/usersettings`)
  }

  /**
   * 新しいユーザー情報を作成します。
   * @param {object} formData
   * @returns {*}
   */
  put (param) {
    return ApiClient().put(`/usersettings`, param)
  }
}



// WEBPACK FOOTER //
// ./src/repositories/UserSettingRepository.js